import { render, staticRenderFns } from "./NewProfile.vue?vue&type=template&id=3bf99cb3&scoped=true"
import script from "./NewProfile.vue?vue&type=script&lang=js"
export * from "./NewProfile.vue?vue&type=script&lang=js"
import style0 from "./NewProfile.vue?vue&type=style&index=0&id=3bf99cb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf99cb3",
  null
  
)

export default component.exports